
const BaseUrl = window.globalConfig.baseUrl
//const Domain="https://zapp-dev.zoiftspl.com/CyberbeatAPI/"

export default {
   // GetMyDashboardSummary: BaseUrl + 'api/Dashboard/GetMyDashboardSummary',
   GetDepitTransaction: BaseUrl + 'api/Transaction/DepitTransaction',
};